module.exports = __webpack_public_path__ + "img/operate_sequence.5c0020a9.png";